import React, { useEffect, useState } from "react";
import { Box, IconButton, Menu, MenuItem, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function SelectQuarter({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  errorFormik,
  helperText,
  disabled,
  sx,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const quarters = [
    { id: 1, quarter: "First Quarter" },
    { id: 2, quarter: "Second Quarter" },
    { id: 3, quarter: "Third Quarter" },
    { id: 4, quarter: "Fourth Quarter" },
  ];

  const [selectedQuarter, setSelectedQuarter] = useState(
    quarters?.find((quarter) => quarter.id === value) || null
  );

  useEffect(() => {
    setSelectedQuarter(
      quarters?.find((quarter) => quarter.id === value) || null
    );
  }, [quarters]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (newValue) => {
    setAnchorEl(null);
    if (newValue) {
      onChange?.(name, newValue.id || "");
      setSelectedQuarter(newValue);
    }
  };

  const handleClear = () => {
    onChange?.(name, "");
    setSelectedQuarter(null);
  };

  return (
    <Box>
      <TextField
        label={label}
        placeholder={placeholder}
        name={name}
        variant="outlined"
        size="small"
        disabled={disabled}
        value={selectedQuarter && value ? selectedQuarter.quarter : ""}
        onClick={handleClick}
        onBlur={onBlur}
        error={errorFormik}
        helperText={helperText}
        sx={sx}
        InputProps={{
          endAdornment: (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {selectedQuarter && (
                <IconButton edge="end" onClick={handleClear}>
                  <CloseIcon />
                </IconButton>
              )}
              {!disabled && (
                <IconButton edge="end" onClick={handleClick}>
                  <ArrowDropDownIcon />
                </IconButton>
              )}
            </>
          ),
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose(null)}
      >
        {quarters.map((quarter) => (
          <MenuItem
            sx={{ width: "100%" }}
            key={quarter.id}
            onClick={() => handleClose(quarter)}
          >
            {quarter.quarter}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
